import { Injectable, inject } from '@angular/core';
import { Http, QueryHandlerFor } from '@skylab-angular-shared/core';
import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { fillPlaceholders } from '@skylab-shared/utils';

export interface ProductOffersQueryParameters {
    productId: string;
}

export type ProductOffersItem = ProductOffersInternalItem;

type ProductOffersInternalItem = {
    offerId: string,
    offerName: string,
    offerMarketplace: string,
    offerMarketplaceId: string,
    offerUrl: string
};

type ProductOffersResponse = {
    data: {
        items: ProductOffersInternalItem[],
        metadata: {
            page: number,
            total: number
        }
    }
}

export class ProductOffersQuery extends Query<ProductOffersItem[]> {
    constructor(readonly params: ProductOffersQueryParameters) {
        super();
    }
}

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(ProductOffersQuery)
export class ProductOffersQueryHandler implements QueryHandler<ProductOffersQuery, ProductOffersItem[]> {
    #Url = TaggedUrl.join('Products/:productId/offers', [Tags.SelloApi]);
    #http =  inject(Http) as HttpService;

    async handleAsync(query: ProductOffersQuery): Promise<ProductOffersItem[]> {
        const url = fillPlaceholders(this.#Url, {
            productId: query.params.productId,
        });
        const { data } = await this.#http.get<ProductOffersResponse>(url);

        return data.data.items;
    }
}
